import React from 'react';
import { Box, Button, Skeleton, styled } from '@mui/material';

const StyButtonContainer = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    height: '100%',
}));

export const ApplyChangesButton = ({
    isLoading,
    isDisabled,
    onClick,
    title,
}: {
    isLoading: boolean;
    isDisabled: boolean;
    onClick: () => void;
    title: string;
}): React.ReactElement => (
    <StyButtonContainer>
        {isLoading ? (
            <Skeleton variant="rectangular" width={200} height={40} />
        ) : (
            <Button
                sx={{ color: 'primary' }}
                variant="contained"
                disabled={isDisabled}
                onClick={onClick}
            >
                {title}
            </Button>
        )}
    </StyButtonContainer>
);
